// #region store types
export enum Status {
  LOADING = 'loading',
  ERROR = 'error',
  SUCCESS = 'success',
}
// #endregion

// #region route types
export enum OrderType {
  COLLECTION = 'collection',
  DELIVERY = 'delivery',
}
// #endregion
